<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="2" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-row :gutter="10" style="margin: 1rem 0">
          <CommonExcel ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
          <clear-cache-apply v-if="type==2" />
        </el-row>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <el-table-column label="序号" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template slot-scope="{row,$index}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :show-close="false" title="提示" :before-close="handleClose" :visible.sync="dialog" width="60%">
        <el-table :key="tableKey" size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type == 2 || type==3">
            <el-table-column label="ID" align="center">
              <template slot-scope="{row,$index}"><span> {{ row.id }}</span></template>
            </el-table-column>
            <el-table-column label="bet" align="center">
              <template slot-scope="{row,$index}">
                <el-input-number v-model="row.bet" :controls="false" :min="-1" placeholder="bet" />
              </template>
            </el-table-column>
            <el-table-column label="权重" align="center">
              <template slot-scope="{row,$index}">
                <el-input-number v-model="row.pro" :controls="false" :min="1" placeholder="权重" />
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==4">
            <el-table-column prop="taskType" label="任务类型">
              <template slot-scope="scope">
                <el-select v-model="scope.row.taskType" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in taskType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="target" label="任务值">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.target" placeholder="任务值" />
              </template>
            </el-table-column>
            <el-table-column prop="frequency" label="修正频率">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.frequency" placeholder="修正频率" />
              </template>
            </el-table-column>
            <el-table-column prop="bet" label="下注">
              <template slot-scope="scope">
                <el-select v-model="scope.row.bet" filterable allow-create style="width: 100%;" multiple placeholder="请选择">
                  <el-option
                    v-for="(item, index) in betArr"
                    :key="index"
                    :label="item.value"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="prize" label="进度奖励">
              <template slot-scope="scope">
                <Reward :value="scope.row.props" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type == 5">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="价格" align="center">
              <Price :limit-type="limitType" />
            </el-table-column>
            <el-table-column prop="prize" label="奖励" align="center">
              <template slot-scope="{row,$index}">
                <Reward v-model="row.prize" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button size="small" type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { Message } from 'element-ui'
import { getBetConfig } from '@/api/config/common-cfg'
import Price from '@/components/Price/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { handleImportPrize } from '@/utils'

export default {
  name: 'CoinSLot',
  components: { ClearCacheApply, Price, CommonExcel, Reward },
  data() {
    return {
      tableKey: 0,
      limitType: [2],
      loading: false,
      dialog: false,
      diaLogList: [],
      total: 0,
      list: [],
      type: 2,
      typeArr: { 2: '老虎机配置', 3: '轮盘配置', 4: '奖励配置', 5: '商品配置' },
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      curClass: 'treasure',
      betArr: [],
      taskType: [
        { 'value': 1, 'label': '下注' },
        { 'value': 2, 'label': '获得金币' },
        { 'value': 3, 'label': 'BonusWheel' }
      ]
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getBetCfg()
      this.getList()
    },
    handleClose(done) {

    },
    openDialog(config) {
      this.tableKey++
      this.diaLogList = config
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      if (id != 0) {
        delActAuxiliary({ idList: [id] })
      }
      this.list[this.type].splice(index, 1)
    },
    handleCopy(row) {
      row.id = 0
      this.list[this.type].push(row)
      console.log(this.list[this.type])
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      const typeConversion = {}
      if (this.type == 4) {
        typeConversion['bet'] = 'array'
      }
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name == sheet) {
            this.list[this.type][j].config = handleImportPrize(excelData[i].sheetData, typeConversion)
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, handleImportPrize(excelData[i].sheetData, typeConversion))
        }
      }
    },
    handleSaveConfig() {
      for (const i in this.list[4]) {
        const val = this.list[4][i]
        for (const k in val.config) {
          if (val.config[k].bet.length <= 0) {
            Message({ message: '下注不能为空', type: 'error', duration: 5 * 1000 })
            return
          }
        }
      }
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = this.typeArr[type]
      let tranTitle = {}
      switch (type) {
        case 2:
        case 3:
          tranTitle = { id: 'id', pro: '权重', bet: '下注' }
          break

        case 4:
          tranTitle = { taskType: '任务类型', target: '任务值', frequency: '修正频率', bet: '下注', props: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}}
          break

        case 5:
          tranTitle = { mtype: '类型', sku: '库存', bet: '倍数', price: '价格', prize: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}}
          break
      }
      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], tranTitle)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addRewardDialogList(index) {
      switch (this.type) {
        case 2:
        case 3:
          this.diaLogList.push({ id: this.diaLogList.length + 1, pro: 0, bet: 0 })
          break

        case 4:
          this.diaLogList.push({
            taskType: 1,
            target: 0,
            frequency: 0,
            props: [],
            bet: []
          })
          break
        case 5:
          this.diaLogList.push({ mtype: 1, bet: 1, sku: '', price: 0, coin: 'money1', prize: [] })
          break
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    getBetCfg() {
      getBetConfig().then(res => {
        this.betArr = []
        res.data.forEach(item => {
          this.betArr.push({ label: '下注' + item, value: item })
        })
      })
    }
  }
}
</script>

